(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.amachHeroDrift) return;
    window.amachHeroDrift = true;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var items = [];
    var queued = false;

    function collect() {
      items = [];
      document.querySelectorAll('[data-hero-drift]').forEach(function (hero) {
        var lockup = hero.querySelector('[data-hero-lockup]');
        var content = hero.querySelector('.hero__content');
        if (!lockup || !content) return;
        items.push({
          hero: hero,
          lockup: lockup,
          content: content,
          speed: parseFloat(hero.getAttribute('data-hero-drift')) || 0.45
        });
      });
      update();
    }

    /* Homepage: once the hero has scrolled under the sticky header,
       bring the small header logo back in */
    function revealHeaderLogo() {
      var root = document.documentElement;
      var hero = document.querySelector('body.template-index main .hero');
      if (!hero) {
        root.classList.remove('amach-hero-passed');
        return;
      }
      var header = document.querySelector('.section-header');
      var headerBottom = header ? header.getBoundingClientRect().bottom : 0;
      root.classList.toggle('amach-hero-passed', hero.getBoundingClientRect().bottom <= headerBottom + 1);
    }

    function update() {
      queued = false;
      revealHeaderLogo();
      var viewport = window.innerHeight;
      items.forEach(function (item) {
        if (reduceMotion.matches) {
          item.lockup.style.transform = '';
          return;
        }
        var rect = item.hero.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > viewport) return;

        /* How far the hero has scrolled up past the top of the screen */
        var scrolled = Math.max(0, -rect.top);

        /* Room left below the logo inside the hero, so it never spills out */
        var contentRect = item.content.getBoundingClientRect();
        var lockupRect = item.lockup.getBoundingClientRect();
        var current = parseFloat(item.lockup.dataset.driftY || '0');
        var restingBottom = lockupRect.bottom - current;
        var room = Math.max(0, contentRect.bottom - restingBottom - 24);

        var y = Math.min(scrolled * item.speed, room);
        item.lockup.dataset.driftY = y;
        item.lockup.style.transform = 'translate3d(0, ' + y.toFixed(1) + 'px, 0)';
      });
    }

    function requestUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
    document.addEventListener('shopify:section:load', collect);
    document.addEventListener('shopify:section:unload', function () {
      window.setTimeout(collect, 0);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', collect);
    } else {
      collect();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
